module.exports = __webpack_public_path__ + "static/media/app-store-icon.4a42649f.png";